import {RESOLVE_THEME_FROM_URL, RESOLVE_THEME_FROM_PROGRAM, RESOLVE_THEME_FROM_SETTINGS} from "../actions";
import {Record} from "immutable";
import theme from '../constants/DefaultTheme';
import hash  from 'object-hash';

class ResolvedThemeState extends Record({
    theme,
    hash: hash(theme)
  }) {}

const initialState = new ResolvedThemeState();

const ResolvedThemeReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case RESOLVE_THEME_FROM_URL:
    case RESOLVE_THEME_FROM_PROGRAM:
    case RESOLVE_THEME_FROM_SETTINGS:
      return state
        .set('theme', action.theme)
        .set('hash', hash(action.theme));
    default:
  }
  return state;
};

export const name = 'theme';
export const selector = (state) => state[name];
export default ResolvedThemeReducer;
